// © Microsoft Corporation. All rights reserved.

/**
 * Peregrine flights with prefix
 */
export const PeregrineFlightPrefix = "prg-";

/**
 * OneService flights with prefix
 */
export const OneServiceFlightPrefix = "1s-";

/**
 * Config Service v3 endpoint
 */
export const CrsV3Endpoint = "v3";

/**
 * Git configs indexedDB caching flight
 */
export const GitConfigsIndexedDbTreatment = "prg-gitconfigs-t";

/**
 * Git configs flight prefix
 */
export const GitConfigsFlightPrefix = "prg-gitcfgs-";